class Countdown extends HTMLElement {
  constructor() {
    super();
    this.endDate = this.getAttribute('end-date');
  }

  connectedCallback() {
    if (this.endDate) {
      this.countDownDate = new Date(`${this.endDate} PST`).getTime();
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.countDownDate - now;

    if (distance < 0) {
      clearInterval(this.interval);
      this.querySelector("#countdown").innerHTML = "EXPIRED";
      this.classList.add('hidden');
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Dividir cada unidad en dígitos individuales
    const daysStr = String(days).padStart(2, '0');
    const hoursStr = String(hours).padStart(2, '0');
    const minutesStr = String(minutes).padStart(2, '0');
    const secondsStr = String(seconds).padStart(2, '0');

    // Actualizar cada dígito por separado
    // Si los elementos existen en el DOM (para días y horas que pueden ser opcionales)
    const daysTensEl = this.querySelector(".days-tens");
    const daysOnesEl = this.querySelector(".days-ones");
    if (daysTensEl && daysOnesEl) {
      daysTensEl.textContent = daysStr[0];
      daysOnesEl.textContent = daysStr[1];
    }

    const hoursTensEl = this.querySelector(".hours-tens");
    const hoursOnesEl = this.querySelector(".hours-ones");
    if (hoursTensEl && hoursOnesEl) {
      hoursTensEl.textContent = hoursStr[0];
      hoursOnesEl.textContent = hoursStr[1];
    }

    // Minutos y segundos (que siempre están presentes)
    this.querySelector(".minutes-tens").textContent = minutesStr[0];
    this.querySelector(".minutes-ones").textContent = minutesStr[1];
    this.querySelector(".seconds-tens").textContent = secondsStr[0];
    this.querySelector(".seconds-ones").textContent = secondsStr[1];
  }
}

customElements.define('countdown-timer', Countdown);